const periodLabels = {
    MONTH_OVER_MONTH: 'MoM',
    PERIOD_OVER_PERIOD: 'PoP',
    YEAR_OVER_YEAR: 'YoY',
};
export const isBasePeriod = (comparisonPeriod) => (comparisonPeriod.comparisonType === 'BASE_PERIOD');
export const getDeltas = (data) => (data || [])
    .filter(({ comparisonPeriod }) => !isBasePeriod(comparisonPeriod))
    .map(({ comparisonPeriod: { comparisonType }, percentChangeToBase }) => ({
    period: periodLabels[comparisonType] || comparisonType,
    value: percentChangeToBase / 100,
}));
